import makeStyles from '@mui/styles/makeStyles';
import { BREAKPOINTS, FONT_26, FONT_36 } from 'constants/styles';

export default makeStyles(
  {
    root: {
      display: 'flex',
      marginTop: 80,
      padding: '40px 32px',
      borderRadius: 30,
      gap: 24,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        borderRadius: 16,
        padding: 0,
        flexDirection: 'column',
        marginTop: 20,
      },
    },
    titleLabel: {
      whiteSpace: 'pre-line',
      flex: 3,
      ...FONT_36,
      marginBottom: 40,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        marginBottom: 24,
        ...FONT_26,
      },
    },
    imageContainer: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        display: 'none',
      },
    },
    image: {
      width: '100%',
      height: '100%',
    },
    container: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
    },

    form: {
      marginLeft: 80,
      maxWidth: 400,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        flex: 1,
        margin: 'initial',
        maxWidth: 'initial',
      },
    },
  },
  { name: 'ContactsWidget' },
);
